"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var react_1 = tslib_1.__importDefault(require("react"));
var get_thumbnail_min_width_attribute_1 = tslib_1.__importDefault(require("../get-thumbnail-min-width-attribute"));
var wrapper_scss_1 = tslib_1.__importDefault(require("./wrapper.scss"));
var SliderWrapper = function (_a) {
    var className = _a.className, ariaLabel = _a.ariaLabel, children = _a.children, onRef = _a.onRef, itemWidth = _a.itemWidth, isRTL = _a.isRTL, style = _a.style;
    return (react_1.default.createElement("section", { style: style, className: (0, classnames_1.default)(wrapper_scss_1.default.container, className), ref: onRef, "aria-label": ariaLabel, tabIndex: 0, "data-thumbnail-min-width": (0, get_thumbnail_min_width_attribute_1.default)(itemWidth), "data-hook": "video-list", dir: isRTL ? 'rtl' : 'ltr' }, children));
};
exports.default = SliderWrapper;
//# sourceMappingURL=wrapper.js.map